import CommitteApprovalList from "../../features/CommitteeApprovalManagement/CommitteeApprovalList";


const CommitteApprovalManagement = () =>{
return(<>
    <CommitteApprovalList/>
</>)
}
export default CommitteApprovalManagement;